import _slicedToArray from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as tslib_1 from "tslib";
import React, { useState, useMemo } from 'react';
import _ from 'lodash';
import { TextboxField } from '../';

var formatPercentValue = function formatPercentValue(value) {
  // Convert to number if string
  var numValue = typeof value === 'number' ? value : parseFloat(value);
  if (isNaN(numValue)) return '0%'; // Convert to string with max 4 decimal places

  var formatted = numValue.toFixed(4); // Remove trailing zeros after decimal point

  while (formatted.includes('.') && formatted.endsWith('0')) {
    formatted = formatted.slice(0, -1);
  } // Remove decimal point if it's the last character


  if (formatted.endsWith('.')) {
    formatted = formatted.slice(0, -1);
  }

  return "".concat(formatted, "%");
};

export var PercentField = function PercentField(_a) {
  var type = _a.type,
      step = _a.step,
      value = _a.value,
      locale = _a.locale,
      props = tslib_1.__rest(_a, ["type", "step", "value", "locale"]);

  var id = props.id,
      form = props.form;
  var values = form.values,
      handleBlur = form.handleBlur,
      setValues = form.setValues;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hasFocus = _useState2[0],
      setHasFocus = _useState2[1];

  var formattedValue = useMemo(function () {
    var percentValue = value || _.get(values, id);

    return _.isNumber(percentValue) || percentValue ? formatPercentValue(percentValue) : '0%';
  }, [id, value, values]);
  var overrideProps = useMemo(function () {
    if (hasFocus) {
      return {
        inputMode: 'decimal',
        // Allow up to 4 decimal places during input
        step: '0.0001'
      };
    }

    return {
      value: formattedValue
    };
  }, [hasFocus, formattedValue]);

  var onFocus = function onFocus() {
    // When focusing, set form value to raw number without % symbol
    var rawValue = formattedValue.replace('%', '');
    setValues(_.set(Object.assign({}, values), id, rawValue));
    setHasFocus(true);
  };

  var onBlur = function onBlur(e) {
    if (!e.target.value) {
      setValues(_.set(Object.assign({}, values), id, 0));
      setHasFocus(false);
      handleBlur(e);
      return;
    } // Parse the input value, keeping up to 4 decimal places


    var numericValue = parseFloat(parseFloat(e.target.value).toFixed(4)); // Clamp between 0 and 100

    var clampedValue = Math.min(100, Math.max(0, numericValue));
    setValues(_.set(Object.assign({}, values), id, clampedValue));
    setHasFocus(false);
    handleBlur(e);
  };

  return React.createElement(TextboxField, Object.assign({}, props, overrideProps, {
    onfocus: onFocus,
    onblur: onBlur
  }));
};